import React from 'react';
export function FantasyFooter({
  blockName,
  onLoadMoreClicked,
  isLoadMoreVisible,
}){
  const classPrefix = `${ blockName }__footer`;
  return (
    <footer
      className={ `${ classPrefix }` }
    >
      { isLoadMoreVisible ? 
      <button
        type='button'
        className={ `${ classPrefix }-load-more-button` }
        onClick={ onLoadMoreClicked }
      >
        Load More
      </button>
        : false 
      }
    </footer>
  );
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/fantasy/components/fantasyFooter.js